import { Box, Divider, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    gap: "20px",
    flexDirection: "column"
  },
  toolTitle: {
    color: "#000000"
  },
  text: {
    fontFamily: "inherit",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    color: "#000000"
  },
  divider: {
    backgroundColor: "lightGray", marginBottom: "5px"
  }
}));

export const Tools = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Box className={classes.container}>
      <Box>
        <Typography className={classes.toolTitle}>{t('inference:orderSearchTool')}</Typography>
        <Divider className={classes.divider} />
        <pre className={classes.text}>
          {t('inference:orderSearchDescription')}
        </pre>
      </Box>
      <Box>
        <Typography className={classes.toolTitle}>{t('inference:orderInfoTool')}</Typography>
        <Divider className={classes.divider} />
        <pre className={classes.text}>
          {t('inference:orderInfoDescription')}
        </pre>
      </Box>
      <Box>
        <Typography className={classes.toolTitle}>{t('inference:partySearchTool')}</Typography>
        <Divider className={classes.divider} />
        <pre className={classes.text}>
          {t('inference:partySearchDescription')}
        </pre>
      </Box>

      <Box>
        <Typography className={classes.toolTitle}>{t('inference:userInfoTool')}</Typography>
        <Divider className={classes.divider} />
        <pre className={classes.text}>
          {t('inference:userInfoDescription')}
        </pre>
      </Box>
    </Box>
  );
};
